export const Dropdown = ({dropdownValue, handleDropdownClick}) => {
    return <div className="dropdown-div">
                  {dropdownValue.map((drd, idx) => (
                    <select
                      key={idx}
                      className={`dropdown-style dropdown-style-${idx}`}
                      onClick={() => handleDropdownClick(drd)}
                    >
                      <option value={drd}>{drd}</option>
                    </select>
                  ))}
                </div>
}